import type { FC } from 'react';
import { useEffect } from 'react';

type LoadingDoneType = {
	onLoad: () => void;
};

export const LoadingDone: FC<LoadingDoneType> = ({ onLoad }) => {
	useEffect(() => {
		onLoad();
	}, [onLoad]);

	return null;
};
